import React, { useState, useEffect, useRef } from "react";
import "./Search.css";
import Nav from "../Nav/Nav";
import Culture from "../Culture/Culture";
import LogoLoader from "../Loading/Loading";
import AboutUs from "../AboutUs/AboutUs";
import OurHistory from "../OurHistory/OurHistory";
import OurTeam from "../OurTeam/OurTeam";
import Transition from "../Transition/Transition";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Crosshair from "../CrossHair/CrossHair";
import Footer from "../Footer/Footer";


const Search = () => {
  const containerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const targetId = searchParams.get("targetId") || location.state?.targetId;


  const videos = [
    "https://storage.googleapis.com/vilal/VIDEO-1-TE-COVERI-KRYESOR-1.mp4",
    "https://storage.googleapis.com/vilal/video-vila-1.MOV",
    "https://storage.googleapis.com/vilal/video-vila-2.MOV"
  ];
  const [videoIndex, setVideoIndex] = useState(0);


  const handleNext = () => {
    setVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  const handlePrev = () => {
    setVideoIndex((prevIndex) => (prevIndex - 1 + videos.length) % videos.length);
  };

  

  useEffect(() => {
      if (!isLoading && targetId) {
        const timeout = setTimeout(() => {
          const el = document.getElementById(targetId);
          if (el) {
            el.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }, 1500);
  
        return () => clearTimeout(timeout);
      }
    }, [isLoading, targetId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2650);
    return () => clearTimeout(timer);
  }, []);

  const [isAlbanian, setIsAlbanian] = useState(() => {
    // Initialize from localStorage, default to true (Albanian) if not set
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      // Save the new language preference to localStorage
      localStorage.setItem('language', JSON.stringify(newLanguage));
      return newLanguage;
    });
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <LogoLoader />
      </div>
    );
  }

  return (
    <>
    {window.innerWidth > 768 && (
        <Crosshair containerRef={containerRef} color="#dcdcdc"/>
      )}
    <div ref={containerRef} className="searchpage-container">
      
      <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />

      <div className="video-container">
        {/* Video Navigation Arrows */}
        <div className="video-controls">
          <button 
            className="prevTop-button-outside" 
            onClick={handlePrev}
          >
            <img src="/prevup.png" alt="Prev" className="prevProTop-btn-img"/>
          </button>
          <button 
            className="next-button-outside" 
            onClick={handleNext}
          >
            <img src="/nextup.png" alt="Next" className="nextPro-btn-img"/>
          </button>
        </div>

        <video 
          width="100%" 
          height="auto" 
          loop 
          autoPlay 
          muted 
          playsInline 
          preload="auto"
          key={videos[videoIndex]} 
        >
          <source src={videos[videoIndex]} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="hero-title">
            <h1 className="overlay-text">
              {isAlbanian ? (
                <>
                  Ndërtim që <br />
                  <strong>
                    <span className="search-protest-font">Sfidon</span>
                    <img
                      src="/underlined2-1.png"
                      alt="Underline decoration"
                      className="underline-image"
                    />
                  </strong>{" "}
                  Kohën
                </>
              ) : (
                <>
                  Building that <br />
                  <strong>
                    <span className="search-protest-font">stands</span>
                    <img
                      src="/underlined2-1.png"
                      alt="Underline decoration"
                      className="underline-image"
                    />
                  </strong>{" "}
                  the test of time
                </>
              )}
            </h1>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
      <div id="aboutUs">
        <AboutUs isAlbanian={isAlbanian} />
      </div>
      <div id="ourCulture">
        <Culture isAlbanian={isAlbanian} />
      </div>
      <div id="ourHistory">
        <OurHistory isAlbanian={isAlbanian} />
      </div>
      <div id="ourTeam">
        <OurTeam isAlbanian={isAlbanian} />
      </div>
      <Transition isAlbanian={isAlbanian} />
    </div>
      <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default Search;
